// extracted by mini-css-extract-plugin
export default {"popup":"_2ftjVuYPhOFznErxgIFaLb","item":"_1ARLY_RD3Wi1-qvYInB_J9","button":"_38yJ7pmpeONS_2dU4fTOSG"};